/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PolicyFormat = zod.enum(['text', 'image']);

export type PolicyFormat = zod.input<typeof PolicyFormat>;
export type PolicyFormatOutput = zod.output<typeof PolicyFormat>;
